export default __webpack_public_path__ + "static/media/interior-styling.inline.090e09ac.svg";